module.exports = __webpack_public_path__ + "img/slide_interno_obleas.15383c3f.webp";